import React from 'react';
import './Loader.css';

/**
 * Normal / simple full-screen loader (three white dots).
 * Used on every page EXCEPT the home page — the home page shows the
 * branded Splash instead. Shared across all origins.
 */
export default function Loader({ text }) {
  return (
    <div className="loader-overlay">
      <div className="three-dots-loading">
        <span></span>
        <span></span>
        <span></span>
      </div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
}
